import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { loadMercadoPago } from '@mercadopago/sdk-js';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HttpClientModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'acozam';
  

  // async ngOnInit() {
  //   await loadMercadoPago();
  //   const mp = new MercadoPago("YOUR_PUBLIC_KEY", {
  //     locale: "es-MX"
  //   });
  // }
}


// <script src="https://sdk.mercadopago.com/js/v2"></script>


// const mp = new MercadoPago('YOUR_PUBLIC_KEY');
// const bricksBuilder = mp.bricks();

// mp.bricks().create("wallet", "wallet_container", {
//   initialization: {
//       preferenceId: "<PREFERENCE_ID>",
//   },
// customization: {
// texts: {
//  valueProp: 'smart_option',
// },
// },
// });


// MercadoPagoService